import { ReactNode } from 'react';

import { Box } from '@mui/material';

import { ReactComponent as IcIturan } from 'assets/icons/ic-ituan-blue.svg';

const ContainerBase = ({ children }: { children: ReactNode }) => {
    return (
        <Box position='relative' display='grid' gridAutoRows='1fr auto' height='100%' width='100%' justifyContent='center' alignItems='center' sx={{
            overflowY: 'auto'
        }}>
            <Box position='absolute' margin='0 auto' width='fit-content' height='fit-content' sx={{
                inset: '0',
                top: { xs: '2.25rem', md: '3.38rem' },
                'svg': {
                    height: '3.38rem'
                }
            }}>
                <IcIturan />
            </Box>
            <Box width='100%' sx={{
                padding: { xs: '6rem .75rem 0', md: '7rem .75rem 0' },
            }}>
                {children}
            </Box>
            <Box bgcolor='secondary.main' sx={{ minWidth: '100vw', height: { xs: '3.31rem', md: '2.5625rem' } }} />
        </Box>
    );
}

export default ContainerBase;